import { useHistory, useLocation } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { getMediaQueryState } from 'redux/selectors';
import { logoutUser } from 'services';
import EllaLogo from 'images/Ella-logo-only.svg';
import WelcomeLink from './WelcomeLink';
import styles from '../welcome.module.css';

export function Welcome(props) {
	const { isMd } = useSelector(getMediaQueryState);
	const child = useSelector((state) => state.lifebooks.child);

	const { push } = useHistory();
	const location = useLocation();

	const { user } = props;
	const isCaseManager = user.type === 'case-manager';

	const welcomeName = isCaseManager
		? 'Connect Our Kids'
		: user.firstname
		? user.firstname
		: '';

	const handleClick = (linkto) => {
		if (linkto === 'lifebook') {
			push({ pathname: isCaseManager ? '/connect/' : '/lifebooks/' });
		} else if (linkto === 'profile') {
			push({
				pathname: isCaseManager
					? `/connect/profile/${child.id}`
					: '/account/',
			});
		} else if (linkto === 'support') {
			push({
				pathname: isCaseManager
					? '/connect/support/contact'
					: '/support/contact',
			});
		} else if (linkto === 'logout') {
			logoutUser();
		}
	};

	return (
		<div className={styles.welcomeRoot}>
			<div className={!isMd ? styles.container : styles.smallContainer}>
				<img
					className={styles.welcomeLogo}
					src={EllaLogo}
					alt='Ella Elephant'
				/>
				<div
					className={
						!isMd ? styles.welcomeTitle : styles.smallTitle
					}>{`Welcome back, ${welcomeName}!`}</div>
				<div className={!isMd ? styles.welcomeSubject : styles.smallSubject}>
					Keeping Track Of What Matters.
				</div>
				<div className={styles.linkRootContainer}>
					{location.pathname !==
						(isCaseManager ? '/connect/' : '/lifebooks/') && (
						<WelcomeLink
							name={'LifeBook'}
							icon={'lifeBook'}
							onClick={() => handleClick('lifebook')}
						/>
					)}
					{(!isCaseManager || child?.id) &&
						location.pathname !==
							(isCaseManager
								? `/connect/profile/${child.id}`
								: '/account/') && (
						<WelcomeLink
							name={isCaseManager ? 'Child Profile' : 'User Profile'}
							icon={'profile'}
							onClick={() => handleClick('profile')}
						/>
					)}
					{location.pathname !==
						(isCaseManager ? '/connect/support/contact' : '/support/') && (
						<WelcomeLink
							name={'Support'}
							icon={'support'}
							onClick={() => handleClick('support')}
						/>
					)}
					<WelcomeLink
						name={'Logout'}
						icon={'logout'}
						onClick={() => handleClick('logout')}
					/>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = ({ user: { user } }) => {
	return { user };
};

export default connect(mapStateToProps)(Welcome);
